
import { LabelLayout } from "@/utils/label-layout/label-layout";
import { TextBlock } from "@/utils/label-layout/text-block";
import { TextLine } from "@/utils/label-layout/text-line";
import { Model } from "@/utils/models/model";
import { Condition } from "@/utils/condition/condition";
import { PropSelectGroup } from "@/utils/prop-select/prop-select-group";
import { getConditionPropSelectGroupForModel } from "@/utils/prop-select/browse-to-condition-prop-group";
import AppTextLineSettings from "./TextLineSettings.vue";
import AppConditionsEditModal from "@/components/layout-editor/ConditionsEditModal.vue";
import Vue from "vue";

export default Vue.extend({
	data(){
		return {
			toEditLineIndex: -1,
			editConditionsLineIndex: -1
		};
	},
	props: {
		block: {
			type: Object as ()=>TextBlock,
			required: true
		},
		model: {
			type: Object as ()=>Model,
			required: true
		},
		layout: {
			type: Object as ()=>LabelLayout,
			required: true
		}
	},
	computed: {
		toEditLine():TextLine | undefined {
			return this.block.Lines[this.toEditLineIndex];
		},
		editConditionsLine():TextLine | undefined {
			return this.block.Lines[this.editConditionsLineIndex];
		},
		conditionsPropSelectGroup():PropSelectGroup {
			return getConditionPropSelectGroupForModel(this.model.modelName);
		}
	},
	methods: {
		addNewLine(){
			let line = new TextLine();
			this.block.Lines.push(line);
			this.toEditLineIndex = this.block.Lines.length-1;
		},
		editLine(i:number){
			this.toEditLineIndex = i;
		},
		deleteLine(i:number){
			this.toEditLineIndex = -1;
			this.block.Lines.splice(i,1);
		},
		copyStyleToAllLines(line:TextLine){
			this.block.applyStyleToAllLines(line.Style, line.PreTextStyle, line.PropStyle, line.PostTextStyle);
			this.$wf.notify(this.$ct("styles-applied"), "success", 3000, "check");
		},
		onTextLineInput(line:TextLine){
			console.log("On text line settings", line);
			if (this.toEditLineIndex == -1) return;
			if (!line) return;
			this.$set(this.block.Lines, this.toEditLineIndex, line);
		},
		onConditionsInput(conditions:Condition[]){
			if (this.editConditionsLineIndex == -1) return;
			this.block.Lines[this.editConditionsLineIndex].Conditions = conditions;
		}
	},
	components: {
		AppTextLineSettings,
		AppConditionsEditModal
	},
	i18nEx: {
		componentPrefix: "components.layout-editor"
	}
});
